const PAGES = {
  HOME: 'home',
  UPLOADS: 'uploads',
  SENT: 'sent',
  RECEIVED: 'received',
  ASSIGNED: 'assigned',
  REFERRED: 'referred',
  VOICE: 'voice',
  SETTINGS: 'user',
};

const RECEIVER_TYPES = {
  RECEIVED_FAX: 'received_fax',
  EMAIL_ATTACHMENT: 'email_attachment',
  RECEIVER: 'receiver',
  UPLOADED_RECORD: 'uploaded_record',
  JOTFORM_SUBMISSION: 'jotform_submission',
  // Wired up in PR2 (eng-1304-reply-emr-actions). Constant is part of PR1 groundwork only.
  REPLY: 'reply',
};

export { PAGES, RECEIVER_TYPES };
